import { useMutation, type UseMutationResult } from '@tanstack/react-query';

export type SetCardStatusRequest = {
    cardId: string;
    newStatus: number;
};

export type SetCardStatusResponse = {
    success: boolean;
    message?: string;
    card?: {
        id: string;
        status: number;
    };
};

const useSetCardStatusMutation = (): UseMutationResult<SetCardStatusResponse, Error, SetCardStatusRequest> => {
    return useMutation({
        mutationFn: async(body: SetCardStatusRequest) => {
            const response = await fetch(`/api/Indue/cards/${body.cardId}/status`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ newStatus: body.newStatus }),
            });
            if (!response.ok) {
                throw new Error('Failed to update card status');
            }

            const responseData = await response.json();

            if (!responseData) {
                throw new Error('Failed to update card status');
            }

            return responseData as SetCardStatusResponse;
        },
    });
};

export default useSetCardStatusMutation;
